export const CONFIG = "config";

export const EXCHANGE_SERVICE_CODE_TO_OMIT = "1^03";
